// Devam Paneli grafik yardımcıları (saf; testlenir).

/** Ardışık hafta sonu / tatil günlerini (dizideki sıraya göre) tek gölge aralığında birleştirir: [{ x1, x2 }]. */
export function nonWorkingRuns(days) {
  const runs = [];
  let current = null;
  (days || []).forEach((day) => {
    if (day.dayKind === 'weekend' || day.dayKind === 'holiday') {
      if (current) current.x2 = day.date;
      else current = { x1: day.date, x2: day.date };
    } else if (current) {
      runs.push(current);
      current = null;
    }
  });
  if (current) runs.push(current);
  return runs;
}

// Yığılmış çubuk dilim sırası (renk varlığı izler).
export const STACK_KEYS = ['latePerCapita', 'earlyPerCapita', 'absentPerCapita'];

/**
 * Yığılmış yatay çubukta köşe yarıçapı [sol-üst, sağ-üst, sağ-alt, sol-alt]: yalnız SON sıfır-olmayan dilimin veri
 * ucu 4px yuvarlak, taban kare.
 */
export function segmentRadius(row, key) {
  const lastNonZero = [...STACK_KEYS].reverse().find((k) => Number(row?.[k]) > 0);
  return key === lastNonZero ? [0, 4, 4, 0] : [0, 0, 0, 0];
}

/** Dilimler arası 2px yüzey boşluğu (kenarlık çizilmez): veri ucundaki dilim dışında genişlik 2px kısalır. */
export function segmentWidth(width, isLast) {
  if (isLast) return width;
  return Math.max(0, width - 2);
}

/** Sağ köşeleri yuvarlatılabilen dikdörtgen yolu. */
export function segmentPath(x, y, width, height, radius) {
  const [, tr, br] = radius;
  const r = Math.max(0, Math.min(Math.max(tr, br), width / 2, height / 2));
  if (r === 0) return `M${x},${y}H${x + width}V${y + height}H${x}Z`;
  return `M${x},${y}H${x + width - r}Q${x + width},${y} ${x + width},${y + r}`
    + `V${y + height - r}Q${x + width},${y + height} ${x + width - r},${y + height}H${x}Z`;
}

/** Günlük Eğilim tablo görünümü: gün başına bir satır (gelecek günlerin değerleri null). */
export function trendTableRows(days) {
  return (days || []).map((d) => ({
    date: d.date, dayKind: d.dayKind, late: d.late, early: d.early, absent: d.absent,
  }));
}
